import QuickFilter from './QuickFilter';

export default QuickFilter;
